import script from "./CoachEditView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoachEditView.vue?vue&type=script&setup=true&lang=ts"

import "./CoachEditView.vue?vue&type=style&index=0&id=5efc5106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efc5106"]])

export default __exports__